document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.main-image-track');
  const images = Array.from(document.querySelectorAll('.carousel-image'));
  const thumbnails = Array.from(document.querySelectorAll('.thumbnail'));
  const variantSelect = document.getElementById('product-select');
  const priceElement = document.querySelector('.product--price');
  const prevArrow = document.querySelector('.prev-arrow');
  const nextArrow = document.querySelector('.next-arrow');

  if (!track || !images.length || !priceElement) return;

  let currentIndex = 0;
  const productData = window.productData;

  // --- Format money ---
  const formatMoney = (cents) => {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    return `${productData.currency_symbol || '$'}${(cents / 100).toFixed(2)}`;
  };

  // --- Update price ---
  const updatePrice = (variantId) => {
    const variant = productData.variants.find(v => v.id == parseInt(variantId));
    if (!variant) return;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceElement.innerHTML = `<span style="text-decoration: line-through; color: #888;">${formatMoney(
        variant.compare_at_price
      )}</span> <span style="color: red;">${formatMoney(variant.price)}</span>`;
    } else {
      priceElement.textContent = formatMoney(variant.price);
    }
  };

  // --- Update carousel ---
  const updateCarousel = (index) => {
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    currentIndex = index;

    const slideWidth = track.parentElement.offsetWidth;
    track.style.transition = 'transform 0.4s ease-in-out';
    track.style.transform = `translateX(${-currentIndex * slideWidth}px)`;

    thumbnails.forEach(t => t.classList.remove('active'));
    if (thumbnails[currentIndex]) thumbnails[currentIndex].classList.add('active');

    const variantId = images[currentIndex].dataset.variantId;
    if (variantId) {
      if (variantSelect) variantSelect.value = variantId;
      updatePrice(variantId);
    }
  };

  // --- Arrows ---
  prevArrow?.addEventListener('click', () => updateCarousel(currentIndex - 1));
  nextArrow?.addEventListener('click', () => updateCarousel(currentIndex + 1));

  // Hide arrows if only one image
  if (images.length <= 1) {
    prevArrow?.style.setProperty('display', 'none');
    nextArrow?.style.setProperty('display', 'none');
  }

  // --- Thumbnails ---
  thumbnails.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => updateCarousel(idx));
  });

  // --- Variant selection ---
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const selectedId = variantSelect.value;
      const idx = images.findIndex(img => img.dataset.variantId === selectedId);
      if (idx >= 0) updateCarousel(idx);
      updatePrice(selectedId);
    });
    updatePrice(variantSelect.value);
  } else {
    const firstVariantId = images[0].dataset.variantId;
    if (firstVariantId) updatePrice(firstVariantId);
  }

  

  // --- Initialize carousel ---
  updateCarousel(0);
  window.addEventListener('resize', () => updateCarousel(currentIndex));
});

  // --- Out of Stock ---
  form.addEventListener('submit', (e) => {
  const variantId = select.value;
  const variant = window.productData.variants.find(v => v.id == variantId);
  if (!variant || !variant.available) {
    e.preventDefault();
    alert('Sorry, this variant is sold out.');
  }
});
